/* eslint-disable no-shadow */
export var RDModal;
(function (RDModal) {
    RDModal["RD_welcome_modal"] = "RD_welcome_modal";
    RDModal["RD_welcome_modal_shown"] = "RD_welcome_modal_shown";
    RDModal["RD_welcome_modal_closed"] = "RD_welcome_modal_closed";
    RDModal["talk_to_RD_btn"] = "talk_to_RD_btn";
    RDModal["talk_to_RD"] = "talk_to_RD";
    RDModal["RD_modal_video"] = "RD_modal_video";
    RDModal["RD_modal_video_played"] = "RD_modal_video_played";
    RDModal["RD_modal_video_paused"] = "RD_modal_video_paused";
    RDModal["RD_modal_text_RD_btn"] = "RD_modal_text_RD_btn";
    RDModal["text_with_your_RD"] = "text_with_your_RD";
    RDModal["RD_modal_FAQ_accordion"] = "RD_modal_FAQ_accordion";
})(RDModal || (RDModal = {}));
export var ManageDelivery;
(function (ManageDelivery) {
    ManageDelivery["Manage_btn"] = "manage_btn";
    ManageDelivery["Manage_btn_clicked"] = "manage_btn_clicked";
    ManageDelivery["Buy_btn"] = "buy_now_btn";
    ManageDelivery["Buy_btn_clicked"] = "buy_now_btn_clicked";
    ManageDelivery["Snooze_btn"] = "snooze_order_btn_";
    ManageDelivery["Snooze_btn_clicked"] = "snooze_order_clicked_";
    ManageDelivery["Skip_btn"] = "skip_this_order_btn";
    ManageDelivery["Skip_btn_clicked"] = "skip_this_order_btn_clicked";
    ManageDelivery["Change_date_btn"] = "edit_nextOrderDate";
    ManageDelivery["Change_date_btn_clicked"] = "change_order_date_btn_clicked";
    ManageDelivery["Future_tab"] = "future_orders_tab";
    ManageDelivery["Future_tab_clicked"] = "future_orders_clicked";
    ManageDelivery["Edit_address_btn"] = "edit_address_btn";
    ManageDelivery["Edit_address_btn_clicked"] = "edit_address_clicked";
    ManageDelivery["Edit_payment_btn"] = "edit_payment_method_btn";
    ManageDelivery["Edit_payment_btn_clicked"] = "edit_payment_method_clicked";
    ManageDelivery["Edit_nextOrderDate"] = "edit_nextOrderDate";
    ManageDelivery["Save_nextOrderDate"] = "save_nextOrderDate";
    ManageDelivery["Edit_deliveryFrequency"] = "edit_deliveryFrequency";
    ManageDelivery["Save_deliveryFrequency"] = "save_deliveryFrequency";
    ManageDelivery["Snooze_order"] = "snooze_order";
})(ManageDelivery || (ManageDelivery = {}));
export var ViewProduct;
(function (ViewProduct) {
    ViewProduct["More_details_btn"] = "more_details_btn";
    ViewProduct["More_details_btn_clicked"] = "more_details_btn_clicked";
})(ViewProduct || (ViewProduct = {}));
export var EditProduct;
(function (EditProduct) {
    EditProduct["edit_product"] = "edit_product";
    EditProduct["Quantity_selection"] = "quantity_selection";
    EditProduct["Quantity_selected"] = "quantity_selected";
    EditProduct["Quantity_change"] = "quantity_change";
    EditProduct["Quantity_changed"] = "quantity_changed_";
    EditProduct["Flavor_selection"] = "flavor_selection";
    EditProduct["Flavor_selected"] = "_flavor_selected_for_";
    EditProduct["Flavor_change"] = "flavor_change";
    EditProduct["Flavor_changed"] = "flavor_changed_";
    EditProduct["Remove_from_next_order"] = "Remove_from_next_order_btn";
    EditProduct["Removed_from_next_order"] = "_removed_from_next_order";
    EditProduct["Caffeine_toggle"] = "caffeine_toggle";
    EditProduct["Caffeine_remove"] = "remove_caff_from_";
    EditProduct["Caffeine_add"] = "add_caff_to_";
    EditProduct["Creatine_toggle"] = "creatine_toggle";
    EditProduct["Creatine_remove"] = "remove_creatine_from_";
    EditProduct["Creatine_add"] = "add_creatine_to_";
    EditProduct["Apply_to_all"] = "apply_customization_to_all_check";
    EditProduct["Applied_to_all"] = "applied_customization_to_all_";
    EditProduct["EditOrderDate"] = "edit_order_date";
    EditProduct["Edit_servings"] = "edit_servings";
    EditProduct["Edit_flavors"] = "edit_flavors";
    EditProduct["Edit_customizations"] = "edit_customizations";
    EditProduct["Delete_product"] = "remove_from_subscription";
    EditProduct["Add_product"] = "add_product_to_subscription";
})(EditProduct || (EditProduct = {}));
export var SubscriptionV2;
(function (SubscriptionV2) {
    SubscriptionV2["Edit_box"] = "edit_box";
    SubscriptionV2["Cancel_subscription"] = "click_cancel";
    SubscriptionV2["Subscription"] = "subscription_page";
    SubscriptionV2["Future_orders"] = "future_orders";
    SubscriptionV2["skip_futureOrder"] = "skip_futureOrder";
    SubscriptionV2["click_applyPromo"] = "click_applyPromo";
})(SubscriptionV2 || (SubscriptionV2 = {}));
